(function () {
  'use strict';

  angular
    .module('itecAdministracio.entitats.main.administradors')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('entitats.main.submain.administradors', {
        url: '/administradors',
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(entitatsHeaderSubmenuLinksValue){
                return entitatsHeaderSubmenuLinksValue;
              }
            }
          },
          'content@entitats.main.submain': {
            templateUrl: 'entitats/main/administradors/administradors.tpl.html',
            controller: 'EntitatsAdministradorsCtrl',
            controllerAs: 'ctrl'
          }
        },
        breadcrumb: 'DEFAULT_ADMINISTRADORS'
      });
  }
}());
